import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "vueApp",
  class: "unset-width",
  style: {"background":"#000"}
}

import VisualisationComponent from "@/components/visualisation/VisualisationComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'VisualisationApp',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(VisualisationComponent)
      ]),
      _: 1
    }))
  ]))
}
}

})